
import { supabase } from '../../../supabaseClient.js';

// Obtener productos con su BOM (LEFT JOIN equivalente)
export const obtenerProductosCompuesto = async () => {
  let query = supabase
    .from("vista_productos_compuesto")
    .select("*")
    .limit(200);


  const { data, error } = await query;
  console.log("[obtenerProductosCompuesto.repository] Datos obtenidos:", data);
  if (error) {
    console.error("[obtenerProductosCompuesto.repository] Error:", error.message);
    throw new Error("No se pudo obtener");
  }

  return data;

}
